module.exports = __webpack_public_path__ + "img/store6.3215e710.png";